import { createAction } from '@reduxjs/toolkit';

export const COPY_CHILD_ITEM = 'COPY_CHILD_ITEM';
export const INITIALIZE_SHAREDART_COLORS_DICT = 'INITIALIZE_SHAREDART_COLORS_DICT';
export const INITIALIZE_LITE_SHAREDARTS = 'INITIALIZE_LITE_SHAREDARTS';
export const INITIALIZE_LITE_SHAREDART_COLORS = 'INITIALIZE_LITE_SHAREDART_COLORS';
export const INITIALIZE_LITE_TEXT_COLORS = 'INITIALIZE_LITE_TEXT_COLORS';
export const initializeSharedArtColors = createAction(INITIALIZE_SHAREDART_COLORS_DICT);
export const initializeLiteSharedArts = createAction(INITIALIZE_LITE_SHAREDARTS);
export const initializeLiteSharedArtColors = createAction(INITIALIZE_LITE_SHAREDART_COLORS);
export const initializeLiteTextColors = createAction(INITIALIZE_LITE_TEXT_COLORS);
